import backendAPI from './httpCommon'

export const getCustomerList = async () => {
    const res = await backendAPI.get('/organizations').then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getUsers = async () => {
    const res = await backendAPI.get('/users').then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const assignRole = async (data) => {
    const res = await backendAPI.post('/assign_role', data).then((rs) => rs)
    return res
}

/**
 * Roles the logged in user is allowed to assign/revoke for a target user.
 * Exactly one of organizationId / regionId must be provided.
 */
export const getRoleOptions = async ({ targetUserId, organizationId = null, regionId = null }) => {
    const params = new URLSearchParams({ target_user_id: targetUserId })
    if (organizationId != null) {
        params.set('organization_id', organizationId)
    } else if (regionId != null) {
        params.set('region_id', regionId)
    }

    const res = await backendAPI.get(`/user/role-options?${params.toString()}`).then((rs) => (rs.ok ? rs.data : null))
    return res
}

export const getUser = async (kcId) => {
    const res = await backendAPI.get(`/user?user_id=${kcId}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const revokeRole = async (data) => {
    const res = await backendAPI.delete('/revoke_role', {}, { data }).then((rs) => rs)
    return res
}

export const getUserRegions = async (kcId) => {
    const res = await backendAPI.get(`/user/regions?user_id=${kcId}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const assignRegionRole = async (data) => {
    const res = await backendAPI.post('/user/regions/assign_role', data).then((rs) => rs)
    return res
}

export const revokeRegionRole = async (data) => {
    const res = await backendAPI.delete('/user/regions/revoke_role', {}, { data }).then((rs) => rs)
    return res
}

export const inviteUser = async (data) => {
    const res = await backendAPI.post('/user/invite', data).then((rs) => rs)
    return res
}

export const createNewOrganization = async (data) => {
    const res = await backendAPI.post('/organization', data).then((rs) => rs)
    return res
}
